<template>
   <div id="app">
  <div id="appInside" >
    
 <div v-if="!$store.state.hideNavBar" style="margin-top:55px" >

    </div>


      <nav id="navbar" v-if="!$store.state.hideNavBar"  style="z-index: 10" class="navbar navbar-expand-lg navbar-light w-100 ">

    <br />
    <div style="  font-size: 0.9em; max-width:100%" class="container main">

      <router-link to="/" class="title navbar-brand fix_img" href="https://seasoncast.com"><img style="height:23px"  height="80" src="./assets/logo.svg"
          alt="SeasonCast"></router-link>


      <button  class="navbar-toggler" type="button" data-toggle="collapse" data-target="#collapsibleNavbar">
        <span class="navbar-toggler-icon"></span>
      </button>
      
      <div @blur="search('')" class="collapse navbar-collapse justify-content-end" id="collapsibleNavbar">
            <form class="form-inline my-2 my-lg-0 mx-auto  " style="margin-left:5px" action="https://seasoncast.com/search">
      <input class="search-input form-control mr-sm-1 col-xs-4  "  autocomplete="off" v-model="query" @focus="search(query)" @keyup="search(query)"    type="search" name="q" v-bind:placeholder="$t('Search')" aria-label="Search">
      <button class="btn btn-outline-dark my-2 my-sm-0 search-btn" type="submit"><i class="fa fa-search" aria-hidden="true"></i></button>
      <div style="position: relative;  left:0%; width: 100%">
<div class="searchResult " style=" position: absolute; width:450px; top: 0px; background-color:white">
        <div  class=" p-2" v-for="result in results" v-bind:key="result.id" v-bind:onclick="'window.location = \'/'+result.id+'\''" >
      <div style="cursor:pointer" class="seasoncast-card">
     <b v-text="result.name"></b><br />
      <small >@{{result.id}}</small>
     </div>
      </div>
       </div>
</div>
    </form>
        <ul class="navbar-nav" style="">
            
        <li  class="nav-item">
        <a v-tooltip="$t('broadcasting-guide')" class="nav-option nav-link" href="/StartBroadcasting"><i class="fas fa-broadcast-tower"></i><span class="d-lg-none 
"> {{ $t('broadcasting-guide') }}</span></a>
          </li>
          
               <li  class="nav-item">
        <a  v-tooltip="$t('revenue-calculator')" class="nav-option nav-link" href="/GenerateIncome"><i class="fas fa-ticket-alt"></i><span class="d-lg-none 
">{{ $t('revenue-calculator') }}</span></a>
          </li>
              <li  class="nav-item">
        <a  v-tooltip="$t('broadcaster-pricing')" class="nav-option nav-link" href="/Pricing"><i class="fas fa-tag"></i><span class="d-lg-none 
"> {{ $t('broadcaster-pricing') }}</span></a>
          </li>
             <li  class="nav-item">
        <a v-tooltip="$t('support')" class=" nav-option nav-link" href="/Support"><i class="fas fa-info-circle"></i><span class="d-lg-none 
"> {{ $t('support') }}</span></a>
          </li>
   <li  class="nav-item" style="padding-left:5px; ">
        <a class="nav-option nav-link  btn-primary"  style="color:white; background-color: rgb(60, 60, 134); border-radius:0.2em; padding-left:5px;" href="/account"><i class="fas fa-user"></i> {{ $t('MyAccount') }}</a>
          </li>
        </ul>
     
      </div>
    </div>

  </nav>

 
  <div class="">

   <router-view/>
  </div>
  </div>
    

      <div class="sc-footer" >
    <div class="container">
      <div class="row">
        <div class="col-6">
          <div v-if="!$store.state.hideNavBar" class="text-left links centerText">
            <router-link to="/GetApp" >{{ $t('download-mobile-app') }}</router-link> |
            <router-link to="/StartBroadcasting" >{{ $t('broadcast-your-event') }}</router-link> <br />  <a href="https://app.termly.io/document/privacy-policy/76905ecb-92bd-4929-90a5-5983694a33d4">{{ $t('privacy') }}</a> |
            <a href="https://app.seasoncast.com/info/TermsOfService.html">{{ $t('terms') }}</a> |
            <router-link to="/Support">{{ $t('contact-support') }}</router-link>
            
          </div>
        </div>
        <div class="col-6">
          <div class="footer centerText">
            <br />
            <small>&copy; {{ new Date().getFullYear()}} SeasonCast Inc</small>
          </div>
        </div>

      </div>
  

    </div>
  </div>
  </div>
</template>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  color: #2c3e50;
  
}
#navbar{
  -webkit-box-shadow:0 4px 4px -4px rgba(0,0,0,.2);
  -moz-box-shadow: 0 4px 4px -4px rgba(0,0,0,.2);
  box-shadow: 0 4px 4px -4px rgba(0,0,0,.2);
  position: fixed; /* Set the navbar to fixed position */
  top: 0; /* Position the navbar at the top of the page */
  width: 100%;
  z-index: 1000;
  background-color: rgba(255, 255, 255, 0.99);
}
.placeholderNav{
  margin-top: 96px;
  
}
@media screen and (max-width: 900px) {
  .mobile-grid{
  display: grid; gap: 10px;
}
}
  


.nav-link{

}

  #appInside{
      min-height: 100vh;
    }
    .sc-footer{
      background-color: #2d2d54;
color:white;
text-align:center;

padding-top:4vh;
padding-bottom:4vh;
 color: #ffffff;
  font-weight: 600;
    }
    .links{
      text-align: center;
    }
    .links a {
  color:white;
    font-size: 0.9rem;
}
.footer {
  text-align: right;
  font-size: 0.9rem;
 
}
</style>
<style>
.seasoncast-card {
  background-color: white;
  padding: 1.2rem;
  border-radius: 0.3rem;
  border: 1px solid rgb(218, 218, 218);
  
      border: 1px solid rgb(233, 233, 233);
    
}
.seasoncast-card-item {
  background-color: white;
  padding: 0.4rem;
  border-radius: 0.3rem;
  border: 1px solid rgb(218, 218, 218);
  
      border: 1px solid rgb(233, 233, 233);
    
}
.fix_img{
  padding: 5px
}

@media (max-width: 768px) {
.search-btn{
  width:100%
}
.search-input{
  width:100% !important;
  margin-bottom: 5px;
}

.nav-option{
 text-align: center;
}
}

@media (min-width: 768px) {
  .search-input{
  width:450px !important;
}
}
</style>


<script>

import axios from "axios"
import Swal from "sweetalert2"

let API = "https://app.seasoncast.com/"

export default {
  name: 'AppAndNavBar',
  components: {
   
  },
  data: function () {
    return {
      results: [],
      query: this.$route.query.q,
  
    }
  },
  created: async function () {
  
  },
   watch: {
    // whenever question changes, this function will run
//     query: function () {
// this.search(this.query)
//     }
   },
  methods: {

    search: async function (query) {
      if (!query || query == ""){
        this.results = []
return
      }
    let getEventResponse = await axios.post(API+ "v2/global/search", {
    query: query,
  
  }) 

  let responseData = getEventResponse.data

  if (!responseData.success){
       Swal.fire({
  icon: 'error',
  title: 'Server Error',
  text: 'server error: '+JSON.stringify(responseData.reason),
  footer: 'Try action later or refresh page'
})
  }
console.log(responseData)
  this.results = responseData.results
    


    },
  }
}
</script>